module.exports = __webpack_public_path__ + "img/banner.c2e67944.png";